import React from 'react';
import { Button } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import Events from '@/layout/hooks/events';
import Selectors from '@/layout/hooks/selectors';

const RibbonToggle = () => {
  const intl = useIntl();
  const { visible } = Selectors.useRibbonToggle();
  const toggleVisibility = Events.useToggleRibbon();
  return (
    <Button
      className={clsx('ribbon-show-hide', 'aridhia-ribbon-toggle', visible ? undefined : 'show-ribbon')}
      icon={visible ? 'chevron up' : 'chevron down'}
      data-tooltip={intl.formatMessage({ id: visible ? 'ribbon.layout.hide' : 'ribbon.layout.show' })}
      data-position="left center"
      data-variation="mini"
      onClick={toggleVisibility}
    />
  );
};

export default RibbonToggle;
